import React, { useEffect, useState, useMemo } from "react";
import "@styles/pages/MemberZone/Profile.scss";
import { useSelector } from "react-redux";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  Checkbox,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { Trans, useTranslation } from "react-i18next";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { MobileValidationSchema } from "@models/ValidationSchema";
import { countriesData } from "@data/GlobalData";
import { toast } from "react-toastify";
import { getMemberProfile, editMemberProfile } from "@api/memberApi";
import { useDispatch } from "react-redux";
import { setMemberInfoData } from "@store/member/memberInfoSlice";
import SamsungAccountLogin from "@pages/Login/Samsung/SamsungAccountLogin";
import { redirectToSamsungLoginPage } from "@utils/redirectToSamsungLoginPage";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { gaEvent } from "@utils/gaEvent";
const Profile = () => {
  const { t, i18n } = useTranslation();
  const isChinese = i18n.language === "hk";
  const dispatch = useDispatch();
  const memberInfoData = useSelector(
    (state) => state.memberInfo.memberInfoData
  );
  const utmId = localStorage.getItem("utm_id");

  const accessToken = localStorage.getItem("access_token");
  const host = window.location.hostname;
  const index = useMemo(() => {
    if (host === "localhost") {
      return "LocalSALinkUp";
    } else {
      return "SALinkUp";
    }
  }, []);

  const [edit, setEdit] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [initialSelectedProducts, setInitialSelectedProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const productList = [
    "smartphone",
    "flip",
    "fold",
    "buds",
    "watch",
    "monitor",
    "galaxy_book",
    "tablet",
    "galaxy_ring",
    "ai_appliance",
  ];

  const {
    handleSubmit,
    control,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    shouldUnregister: true,
    defaultValues: {
      select: memberInfoData?.country_code
        ? memberInfoData?.country_code
        : "852",
      mobile: memberInfoData?.mobile ? memberInfoData?.mobile : "",
    },
    resolver: yupResolver(MobileValidationSchema),
    context: {
      isEditable: edit && memberInfoData?.is_editable == 1, // ✅ 傳入 context 給 yup
    },
  });

  useEffect(() => {
    if (memberInfoData?.my_favour) {
      const selections = memberInfoData?.my_favour
        .split(",")
        .map((v) => v.trim() === "1");

      const initialSelected = productList.filter((_, idx) => selections[idx]);
      setSelectedProducts(initialSelected);
      setInitialSelectedProducts(initialSelected);
    }
  }, [memberInfoData?.my_favour]);

  const toggleProduct = (product) => {
    setSelectedProducts((prev) =>
      prev.includes(product)
        ? prev.filter((p) => p !== product)
        : [...prev, product]
    );
  };

  const getSelectionOutput = () => {
    const result = productList.map((key) =>
      selectedProducts.includes(key) ? "1" : "0"
    );
    return result.join(",");
  };

  const handleEditClick = () => {
    setEdit(!edit);
  };

  const handleCancelClick = () => {
    setSelectedProducts(initialSelectedProducts); // ✅ reset 勾選狀態
    setEdit(false);
  };

  const getMemberProfileData = async () => {
    try {
      const res = await getMemberProfile();
      dispatch(setMemberInfoData(res.data.Data));
    } catch (err) {
      console.log(err);
    } finally {
    }
  };

  const onSubmit = (data) => {
    gaEvent("clubs_member_zone", "member_profile", "save_button");

    const interests_products_result = getSelectionOutput();
    console.log(interests_products_result);

    const updateData = {
      phone: data?.select + data?.mobile,
      lang: data?.lang,
      my_favour: interests_products_result,
    };

    console.log(updateData);

    const updateProfile = async () => {
      setIsLoading(true);
      try {
        const res = await editMemberProfile(updateData);
        const statusCode = res.data.StatusCode;
        switch (statusCode) {
          case 200:
            toast.success(
              t("status_message:status_code_200_edit_member_profile")
            );
            getMemberProfileData();
            setEdit(false);
            break;
          case 308:
            toast.error(t("status_message:status_code_308"));
            setEdit(false);
            break;
        }
      } catch (err) {
        console.error("更新失敗", err);
        toast.error(t("member:update_fail"));
      } finally {
        setIsLoading(false);
      }
    };

    updateProfile();
  };

  return (
    <Box className="profile-container">
      <Box className="profile-point-history-container">
        <Box className="my-profile-container">
          <Box className="proflie-row-data-container">
            <Typography className="label">
              <Trans i18nKey="member:last_name" />
            </Typography>
            <Typography className="profile-data">
              {memberInfoData?.last_name || "N/A"}
            </Typography>
          </Box>
          <Box className="proflie-row-data-container">
            <Typography className="label">
              <Trans i18nKey="member:first_name" />
            </Typography>
            <Typography className="profile-data">
              {memberInfoData?.first_name || "N/A"}
            </Typography>
          </Box>
          <Box className="proflie-row-data-container">
            <Typography className="label">
              <Trans i18nKey="member:email_address" />
            </Typography>
            <Typography className="profile-data">
              {memberInfoData?.email || "N/A"}
            </Typography>
          </Box>
          <Box className="proflie-row-data-container">
            <Typography className="label">
              <Trans i18nKey="member:mobile_number" />
            </Typography>
            {edit && memberInfoData?.is_editable === 1 ? (
              <Box className="mobile-edit-container">
                <Controller
                  name="select"
                  control={control}
                  render={({ field }) => (
                    <Select
                      {...field}
                      className="edit-country-code"
                      variant="outlined"
                      error={!!errors.mobile}
                    >
                      {countriesData.map((item, key) => (
                        <MenuItem key={key} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
                <Controller
                  name="mobile"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      variant="outlined"
                      className="edit-mobile"
                      error={!!errors.mobile}
                      helperText={
                        errors.mobile && (
                          <Trans i18nKey="member:mobile_number_error" />
                        )
                      }
                    />
                  )}
                />
              </Box>
            ) : (
              <Typography className="profile-data">
                {memberInfoData?.phone || "N/A"}
              </Typography>
            )}
          </Box>
          <Box className="proflie-row-data-container">
            <Typography className="label">
              <Trans i18nKey="member:birthday" />
            </Typography>
            <Typography className="profile-data">
              {isChinese
                ? memberInfoData?.bday_month_hk
                : memberInfoData?.bday_month_hk_en}
            </Typography>
          </Box>
          <Box className="proflie-row-data-container">
            <Typography className="label">
              <Trans i18nKey="member:language" />
            </Typography>
            <Typography className="profile-data">
              {edit ? (
                <Controller
                  name="lang"
                  control={control}
                  defaultValue={memberInfoData?.lang || "hk"}
                  render={({ field }) => (
                    <Select
                      {...field}
                      className="edit-language"
                      variant="outlined"
                      error={!!errors.lang}
                    >
                      <MenuItem value="hk">
                        <Trans i18nKey="member:language_hk" />
                      </MenuItem>
                      <MenuItem value="hk_en">
                        <Trans i18nKey="member:language_hk_en" />
                      </MenuItem>
                    </Select>
                  )}
                />
              ) : memberInfoData?.lang === "hk" ? (
                t("member:language_hk")
              ) : memberInfoData?.lang === "hk_en" ? (
                t("member:language_hk_en")
              ) : (
                "N/A"
              )}
            </Typography>
          </Box>
          {memberInfoData?.member_type !== 3 && (
            <Box className="proflie-row-data-container">
              <Typography className="label">
                <Trans i18nKey="member:connected_account" />
              </Typography>
              {edit ? (
                <Typography className="profile-data">
                  {memberInfoData?.member_type === 1 && (
                    <Button
                      className="loading-button"
                      onClick={() =>
                        redirectToSamsungLoginPage({
                          memberInfoData,
                          accessToken,
                          index,
                          ...(utmId ? { id: utmId } : {}),
                        })
                      }
                    >
                      <Trans i18nKey="member:link_up_sa" />
                    </Button>
                  )}
                  {memberInfoData?.member_type === 2 && (
                    <Box className="status-label green-status">
                      <Trans i18nKey="member:linked" />
                    </Box>
                  )}
                </Typography>
              ) : (
                <Typography className="profile-data">
                  {memberInfoData?.member_type === 2 ? (
                    <Box className="status-label green-status">
                      <Trans i18nKey="member:linked" />
                    </Box>
                  ) : (
                    <Box className="status-label red-status">
                      <Trans i18nKey="member:unlinked" />
                    </Box>
                  )}
                </Typography>
              )}
            </Box>
          )}
        </Box>
        <Box className="point-product-container">
          <Box className="product-container">
            <Typography className="product-title">
              <Trans i18nKey="member:intesets_products" />
            </Typography>
            <Box className="prodcut-item-container">
              {productList.map((productKey) => (
                <Box
                  key={productKey}
                  className={`product-item ${
                    selectedProducts.includes(productKey) ? "checked" : ""
                  }`}
                  onClick={() => {
                    if (edit) toggleProduct(productKey);
                  }}
                  sx={{ cursor: edit ? "pointer" : "default" }}
                >
                  <img
                    className="product-image"
                    src={`${process.env.PUBLIC_URL}/assets/images/member/product_${productKey}.png`}
                    alt={productKey}
                  />
                  <Typography className="product-label">
                    <Trans i18nKey={`member:${productKey}`} />
                  </Typography>
                  <Checkbox
                    className="product-checkbox"
                    disabled={!edit}
                    checked={selectedProducts.includes(productKey)}
                    onChange={() => toggleProduct(productKey)}
                    onClick={(e) => e.stopPropagation()}
                    icon={
                      !edit ? (
                        <Box
                          sx={{
                            width: 12,
                            height: 12,
                            border: "3px dashed #999999",
                            borderRadius: "4px",
                            opacity: 0.5,
                          }}
                        />
                      ) : (
                        <Box
                          sx={{
                            width: 12,
                            height: 12,
                            border: "3px dashed #000000",
                            borderRadius: "4px",
                          }}
                        />
                      )
                    }
                    checkedIcon={
                      !edit ? (
                        <Box
                          sx={{
                            width: 12,
                            height: 12,
                            backgroundColor: "#999999",
                            border: "3px dashed #999999",
                            borderRadius: "4px",
                            opacity: 0.5,
                          }}
                        />
                      ) : (
                        <Box
                          sx={{
                            width: 12,
                            height: 12,
                            backgroundColor: "#000000",
                            border: "3px dashed #000000",
                            borderRadius: "4px",
                          }}
                        />
                      )
                    }
                  />
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box className="button-container">
        {edit ? (
          <>
            <Button
              disableElevation
              disableRipple
              className="button"
              onClick={handleCancelClick}
            >
              <Trans i18nKey="member:cancel" />
            </Button>
            <LoadingButton
              className="loading-button"
              loading={isLoading}
              onClick={handleSubmit(onSubmit)}
            >
              <Trans i18nKey="member:save" />
            </LoadingButton>
          </>
        ) : (
          <>
            <Button
              disableElevation
              disableRipple
              className="loading-button"
              onClick={handleEditClick}
            >
              <Trans i18nKey="member:update2" />
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Profile;
